module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1 && _vm.$route.path.indexOf('_editor') === -1) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "社区列表",
      "name": "first"
    }
  }, [_c('alllist', {
    ref: "alllist",
    attrs: {
      "get-status": _vm.alllist
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f6d1ebf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f6d1ebf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/community/index.vue
// module id = 2657
// module chunks = 0